import { LegendListProps } from './LegendList';
import { Theme, css } from '@emotion/react';

export const legendListContainer =
  (orientation: LegendListProps['orientation'], marginLeft: number, gap: number) =>
  ({ spacing }: Theme) => css`
    display: flex;
    flex-direction: ${orientation === 'horizontal' ? 'row' : 'column'};
    gap: ${spacing(gap)}px;
    margin-left: ${spacing(marginLeft)}px};
  `;

export const legendListItem = ({ spacing }: Theme) => css`
  display: flex;
  align-items: flex-start;
  gap: ${spacing(0.5)}px;
`;

export const legendListItemIcon = css`
  svg {
    display: block;
  }
`;
